export enum InvoiceTelementryEvent {
    DocumentDownloadFailed = "Document_Download_Failed",
}